import type {
	FontId,
	FontVisual,
	TemplateId,
	TemplateVisual,
} from "@/components/landing/StoreCustomizer/types";

export const TEMPLATE_VISUALS: Record<TemplateId, TemplateVisual> = {
	fresh: {
		panelRadius: 22,
		heroRadius: 20,
		buttonRadius: 999,
		buttonStyle: "filled",
		align: "start",
		padding: 22,
	},
	bold: {
		panelRadius: 8,
		heroRadius: 6,
		buttonRadius: 6,
		buttonStyle: "filled",
		align: "start",
		padding: 26,
	},
	classic: {
		panelRadius: 14,
		heroRadius: 10,
		buttonRadius: 4,
		buttonStyle: "outline",
		align: "center",
		padding: 20,
	},
};

export const BRAND_COLORS = [
	{ id: "pink", hex: "#be185d" },
	{ id: "amber", hex: "#f59e0b" },
	{ id: "rose", hex: "#e11d48" },
	{ id: "violet", hex: "#7c3aed" },
] as const;

// `cairo` needs no href: it is the app font, self-hosted via next/font/local
// (src/app/[locale]/layout.tsx), whose generated family name only
// `--font-app` knows. The other Google Fonts here load on demand when picked.
export const FONT_VISUALS: Record<FontId, FontVisual> = {
	system: {
		css: "system-ui, -apple-system, 'Segoe UI', Tahoma, sans-serif",
		href: null,
	},
	cairo: { css: "var(--font-app), system-ui, sans-serif", href: null },
	tajawal: {
		css: "'Tajawal', system-ui, sans-serif",
		href: "https://fonts.googleapis.com/css2?family=Tajawal:wght@400;500;700;800&display=swap",
	},
	rubik: {
		css: "'Rubik', system-ui, sans-serif",
		href: "https://fonts.googleapis.com/css2?family=Rubik:wght@400;500;700;800&display=swap",
	},
};
